import Component from './view'

export default Component
